export const translations = {
  en: {
    // Navigation
    overview: "Overview",
    bookings: "Bookings",
    findServices: "Find Services",
    myVehicles: "My Vehicles",
    discover: "Discover",
    trackDriver: "Track Driver",
    loyalty: "Loyalty",
    payments: "Payments",
    reviews: "Reviews",
    messages: "Messages",
    notifications: "Notifications",
    profile: "Profile",
    favorites: "Favorites",
    referEarn: "Refer & Earn",
    myServices: "My Services",
    earnings: "Earnings",
    analytics: "Analytics",
    businessHours: "Business Hours",
    availability: "Availability",
    payouts: "Payouts",
    availableJobs: "Available Jobs",
    activeDelivery: "Active Delivery",
    history: "History",
    myRatings: "My Ratings",
    myVehicle: "My Vehicle",
    signOut: "Sign out",
    collapse: "Collapse",

    // Auth
    welcomeBack: "Welcome back",
    signIn: "Sign in",
    signUp: "Sign up",
    email: "Email",
    password: "Password",
    firstName: "First name",
    lastName: "Last name",
    selectRole: "Select your role",
    customer: "Customer",
    provider: "Service Provider",
    driver: "Driver",
    alreadyHaveAccount: "Already have an account?",
    dontHaveAccount: "Don't have an account?",

    // Bookings
    bookNow: "Book Now",
    confirmBooking: "Confirm Booking",
    cancelBooking: "Cancel booking",
    rebookService: "Rebook",
    pending: "Pending",
    confirmed: "Confirmed",
    inProgress: "In Progress",
    completed: "Completed",
    cancelled: "Cancelled",
    bookingDate: "Date",
    bookingTime: "Time",
    totalAmount: "Total",
    paymentStatus: "Payment",
    noBookingsFound: "No bookings found",
    pendingReviews: "Pending reviews",
    myReviews: "My reviews",
    rateProvider: "Rate the service provider",
    reviewOptional: "Review (optional)",
    rateDriver: "Rate the driver (optional)",
    shareExperience: "Share your experience...",
    providerReply: "Provider reply",
    rate: "Rate",

    // Services
    searchServices: "Search services...",
    searchGarages: "Search garages, services, drivers...",
    duration: "Duration",
    price: "Price",
    category: "Category",
    description: "Description",
    addService: "Add service",
    updateService: "Update service",
    editService: "Edit service",
    deleteService: "Delete service",
    noServicesYet: "No services available yet.",
    noServicesMatch: "No services match your search.",

    // Payment
    cash: "Cash",
    mpesa: "M-Pesa",
    card: "Card",
    payAtShop: "Pay at the shop on arrival",
    stkPush: "STK push to your phone",
    visaMastercard: "Visa or Mastercard",
    promoCode: "Promo code",
    applyPromo: "Apply",
    discount: "Discount",
    total: "Total",
    downloadInvoice: "Download Invoice",
    paymentMethod: "Payment method",
    totalSpent: "Total spent",
    transactions: "Transactions",
    refunded: "Refunded",
    paymentHistory: "Payment history",
    refundRequests: "Refund requests",
    requestRefund: "Request a refund",
    submitRefund: "Submit refund request",
    selectBooking: "Select booking",
    reason: "Reason",
    explainRefund: "Explain why you are requesting a refund...",

    // Profile
    businessInfo: "Business information",
    businessName: "Business name",
    contactDetails: "Contact details",
    security: "Security",
    saveChanges: "Save changes",
    saveContact: "Save contact details",
    changePassword: "Change password",
    newPassword: "New password",
    confirmPassword: "Confirm password",
    city: "City",
    phone: "Phone number",
    location: "Location",
    shopLocation: "Shop location",
    detectLocation: "Use my current location",
    detecting: "Detecting...",
    locationSet: "Location set",

    // Discover
    discoverServices: "Discover Services",
    providers: "Providers",
    drivers: "Drivers",
    services: "Services",
    nearMe: "Near me",
    filters: "Filters",
    clearFilters: "Clear filters",
    openNow: "Open now only",
    verifiedOnly: "Verified only",
    sortBy: "Sort by",
    nearest: "Nearest first",
    nameAZ: "Name A-Z",
    defaultSort: "Default",
    maxDistance: "Max distance (km)",
    anyDistance: "Any distance",
    priceRange: "Price range (Ksh)",
    online: "Online",
    offline: "Offline",
    verified: "Verified",
    viewProfile: "View profile",
    noProvidersFound: "No providers found",
    noDriversFound: "No drivers found",
    noServicesFound: "No services found",
    backToProviders: "Back to providers",
    servicesOffered: "Services offered",
    businessHoursLabel: "Business hours",
    upcomingClosures: "Upcoming closures",
    hoursNotSet: "Hours not set",
    closedToday: "Closed today",
    closedNow: "Closed now",
    today: "Today",
    owner: "Owner",
    kmAway: "km away",

    // Chat
    typeMessage: "Type a message... (Enter to send)",
    noMessages: "No messages yet. Start the conversation!",
    activeBookings: "active bookings",
    noActiveBookings: "No active bookings to chat about",
    chatWith: "Chat",

    // Loyalty
    yourPoints: "Your points",
    tier: "Tier",
    redeemPoints: "Redeem points",
    pointsBalance: "Points balance",
    cashValue: "Cash value",
    redemptionRate: "Redemption rate",
    tierBenefits: "Tier benefits",
    lifetimeEarned: "Lifetime earned",
    pointsToNext: "pts to",
    maxTier: "Max tier reached",
    pointsEarned: "Points earned from bookings",
    minRedemption: "Minimum redemption",
    pointsToRedeem: "Points to redeem",
    youWillSave: "Saving",
    redeeming: "Redeeming...",
    keepBooking: "Complete bookings to earn more!",

    // Notifications
    markAllRead: "Mark all read",
    noNotificationsYet: "No notifications yet",
    unread: "unread",

    // Common
    loading: "Loading...",
    save: "Save",
    cancel: "Cancel",
    delete: "Delete",
    edit: "Edit",
    back: "Back",
    next: "Next",
    submit: "Submit",
    close: "Close",
    yes: "Yes",
    no: "No",
    details: "Details",
    less: "Less",
    more: "more",
    search: "Search",
    noDataYet: "No data yet",
    error: "Error",
    success: "Success",
    saving: "Saving...",
    processing: "Processing...",
    booking: "Booking...",
    confirm: "Confirm",
    open: "Open",
    closed: "Closed",
    active: "Active",
    inactive: "Inactive",
    optional: "optional",
    note: "Note",
    address: "Address",
    pickup: "Pickup",
    dateAndTime: "Date & Time",
    concierge: "Concierge",
    noVehiclesYet: "No vehicles added yet",
    addVehicleFirst: "Go to My Vehicles to add one first",
    include: "What is included",
    requirements: "Requirements",
    tags: "Tags",
    bookingRef: "Booking ref",
    minutes: "min",
  },

  sw: {
    // Navigation
    overview: "Muhtasari",
    bookings: "Miadi",
    findServices: "Tafuta Huduma",
    myVehicles: "Magari Yangu",
    discover: "Gundua",
    trackDriver: "Fuatilia Dereva",
    loyalty: "Uaminifu",
    payments: "Malipo",
    reviews: "Maoni",
    messages: "Ujumbe",
    notifications: "Arifa",
    profile: "Wasifu",
    favorites: "Vipendwa",
    referEarn: "Alika & Pata",
    myServices: "Huduma Zangu",
    earnings: "Mapato",
    analytics: "Takwimu",
    businessHours: "Saa za Kazi",
    availability: "Upatikanaji",
    payouts: "Malipo ya Nje",
    availableJobs: "Kazi Zinazopatikana",
    activeDelivery: "Usafirishaji Unaoendelea",
    history: "Historia",
    myRatings: "Makadirio Yangu",
    myVehicle: "Gari Langu",
    signOut: "Toka",
    collapse: "Ficha",

    // Auth
    welcomeBack: "Karibu tena",
    signIn: "Ingia",
    signUp: "Jisajili",
    email: "Barua pepe",
    password: "Nenosiri",
    firstName: "Jina la kwanza",
    lastName: "Jina la mwisho",
    selectRole: "Chagua jukumu lako",
    customer: "Mteja",
    provider: "Mtoa Huduma",
    driver: "Dereva",
    alreadyHaveAccount: "Una akaunti tayari?",
    dontHaveAccount: "Huna akaunti?",

    // Bookings
    bookNow: "Agiza Sasa",
    confirmBooking: "Thibitisha Miadi",
    cancelBooking: "Futa miadi",
    rebookService: "Agiza Tena",
    pending: "Inasubiri",
    confirmed: "Imethibitishwa",
    inProgress: "Inaendelea",
    completed: "Imekamilika",
    cancelled: "Imefutwa",
    bookingDate: "Tarehe",
    bookingTime: "Wakati",
    totalAmount: "Jumla",
    paymentStatus: "Malipo",
    noBookingsFound: "Hakuna miadi iliyopatikana",
    pendingReviews: "Maoni yanayosubiri",
    myReviews: "Maoni yangu",
    rateProvider: "Kadiria mtoa huduma",
    reviewOptional: "Maoni (hiari)",
    rateDriver: "Kadiria dereva (hiari)",
    shareExperience: "Shiriki uzoefu wako...",
    providerReply: "Jibu la mtoa huduma",
    rate: "Kadiria",

    // Services
    searchServices: "Tafuta huduma...",
    searchGarages: "Tafuta karakana, huduma, madereva...",
    duration: "Muda",
    price: "Bei",
    category: "Kategoria",
    description: "Maelezo",
    addService: "Ongeza huduma",
    updateService: "Sasisha huduma",
    editService: "Hariri huduma",
    deleteService: "Futa huduma",
    noServicesYet: "Hakuna huduma bado.",
    noServicesMatch: "Hakuna huduma zinazolingana na utafutaji wako.",

    // Payment
    cash: "Taslimu",
    mpesa: "M-Pesa",
    card: "Kadi",
    payAtShop: "Lipa dukani ukifika",
    stkPush: "STK push kwa simu yako",
    visaMastercard: "Visa au Mastercard",
    promoCode: "Msimbo wa promo",
    applyPromo: "Tumia",
    discount: "Punguzo",
    total: "Jumla",
    downloadInvoice: "Pakua Ankara",
    paymentMethod: "Njia ya malipo",
    totalSpent: "Jumla iliyolipwa",
    transactions: "Miamala",
    refunded: "Iliyorudishwa",
    paymentHistory: "Historia ya malipo",
    refundRequests: "Maombi ya kurudisha pesa",
    requestRefund: "Omba kurudisha pesa",
    submitRefund: "Wasilisha ombi la kurudisha",
    selectBooking: "Chagua miadi",
    reason: "Sababu",
    explainRefund: "Eleza kwa nini unaomba kurudishiwa pesa...",

    // Profile
    businessInfo: "Taarifa za biashara",
    businessName: "Jina la biashara",
    contactDetails: "Mawasiliano",
    security: "Usalama",
    saveChanges: "Hifadhi mabadiliko",
    saveContact: "Hifadhi mawasiliano",
    changePassword: "Badilisha nenosiri",
    newPassword: "Nenosiri jipya",
    confirmPassword: "Thibitisha nenosiri",
    city: "Mji",
    phone: "Nambari ya simu",
    location: "Mahali",
    shopLocation: "Mahali pa duka",
    detectLocation: "Tumia mahali pangu sasa",
    detecting: "Inatafuta...",
    locationSet: "Mahali pamewekwa",

    // Discover
    discoverServices: "Gundua Huduma",
    providers: "Watoa Huduma",
    drivers: "Madereva",
    services: "Huduma",
    nearMe: "Karibu nami",
    filters: "Vichujio",
    clearFilters: "Ondoa vichujio",
    openNow: "Wazi sasa tu",
    verifiedOnly: "Waliothibitishwa tu",
    sortBy: "Panga kulingana na",
    nearest: "Wa karibu kwanza",
    nameAZ: "Jina A-Z",
    defaultSort: "Kawaida",
    maxDistance: "Umbali wa juu (km)",
    anyDistance: "Umbali wowote",
    priceRange: "Anuwai ya bei (Ksh)",
    online: "Mtandaoni",
    offline: "Nje ya mtandao",
    verified: "Imethibitishwa",
    viewProfile: "Ona wasifu",
    noProvidersFound: "Hakuna watoa huduma waliopatikana",
    noDriversFound: "Hakuna madereva waliopatikana",
    noServicesFound: "Hakuna huduma zilizopatikana",
    backToProviders: "Rudi kwa watoa huduma",
    servicesOffered: "Huduma zinazotolewa",
    businessHoursLabel: "Saa za biashara",
    upcomingClosures: "Kufungwa kunaokuja",
    hoursNotSet: "Saa hazijawekwa",
    closedToday: "Imefungwa leo",
    closedNow: "Imefungwa sasa",
    today: "Leo",
    owner: "Mmiliki",
    kmAway: "km mbali",

    // Chat
    typeMessage: "Andika ujumbe... (Enter kutuma)",
    noMessages: "Hakuna ujumbe bado. Anza mazungumzo!",
    activeBookings: "miadi inayoendelea",
    noActiveBookings: "Hakuna miadi inayoendelea ya kuzungumzia",
    chatWith: "Zungumza",

    // Loyalty
    yourPoints: "Pointi zako",
    tier: "Kiwango",
    redeemPoints: "Tumia pointi",
    pointsBalance: "Salio la pointi",
    cashValue: "Thamani ya pesa",
    redemptionRate: "Kiwango cha ukombozi",
    tierBenefits: "Faida za kiwango",
    lifetimeEarned: "Jumla iliyopatikana",
    pointsToNext: "pointi hadi",
    maxTier: "Kiwango cha juu kimefikiwa",
    pointsEarned: "Pointi zilizopatikana kutoka miadi",
    minRedemption: "Ukombozi wa chini",
    pointsToRedeem: "Pointi za kutumia",
    youWillSave: "Utaokoa",
    redeeming: "Inatumia...",
    keepBooking: "Endelea kuagiza ili kupata zaidi!",

    // Notifications
    markAllRead: "Soma zote",
    noNotificationsYet: "Hakuna arifa bado",
    unread: "hazijasomwa",

    // Common
    loading: "Inapakia...",
    save: "Hifadhi",
    cancel: "Ghairi",
    delete: "Futa",
    edit: "Hariri",
    back: "Rudi",
    next: "Endelea",
    submit: "Wasilisha",
    close: "Funga",
    yes: "Ndiyo",
    no: "Hapana",
    details: "Maelezo",
    less: "Chini",
    more: "zaidi",
    search: "Tafuta",
    noDataYet: "Hakuna data bado",
    error: "Hitilafu",
    success: "Imefanikiwa",
    saving: "Inahifadhi...",
    processing: "Inachakata...",
    booking: "Inaagiza...",
    confirm: "Thibitisha",
    open: "Wazi",
    closed: "Imefungwa",
    active: "Inafanya kazi",
    inactive: "Haifanyi kazi",
    optional: "hiari",
    note: "Kumbuka",
    address: "Anwani",
    pickup: "Kuchukua",
    dateAndTime: "Tarehe na Wakati",
    concierge: "Huduma ya Kuchukua",
    noVehiclesYet: "Hakuna magari yaliyoongezwa",
    addVehicleFirst: "Nenda kwa Magari Yangu kuongeza kwanza",
    include: "Kilichojumuishwa",
    requirements: "Mahitaji",
    tags: "Vitambulisho",
    bookingRef: "Nambari ya miadi",
    minutes: "dak",
  }
}

export function t(key, lang = "en") {
  return translations[lang]?.[key] || translations["en"][key] || key
}
